import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BaseHttpService } from '@core/data/http/base-http.service';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class GeoDataService extends BaseHttpService {

    private urls: any = {
        geo: '/geo'
    };

    constructor(private httpClient: HttpClient) {
        super(httpClient);
    }

    getCountry(): Observable<any> {
        return this.get(this.urls.geo);
    }
}
